export function ApiScreen() {
  return (
    <iframe
      title="Open Smart Mobility Database API"
      src="/api/v1/docs"
      style={{ border: 0, display: 'block', height: 'calc(100vh - 64px)', width: '100%' }}
    />
  );
}
